import { StateType } from '../index';
import { BaseTutorialStore } from './TutorialReducer';

export const tutorialSelector = (state: StateType) => {
  return state.get('tutorial') as BaseTutorialStore;
};

export const getIsTutorialModeActiveSelector = (state: StateType) => {
  const tutorialStore = state.get('tutorial') as BaseTutorialStore;
  return tutorialStore.isTutorialModeActive;
};

export const getCurrentlyViewedStep = (state: StateType) => {
  const tutorialStore = state.get('tutorial') as BaseTutorialStore;
  return tutorialStore.currentlyViewedStep ?? 0;
};

export const getLastPageSlug = (state: StateType) => {
  const tutorialStore = state.get('tutorial') as BaseTutorialStore;
  return tutorialStore.slug;
};

export const getMaxUnlockedTutorialStep = (state: StateType) => {
  const tutorialStore = state.get('tutorial') as BaseTutorialStore;
  return tutorialStore.maxUnlockedTutorialStep ?? 0;
};

export const getTutorialStartDate = (state: StateType) => {
  const tutorialStore = state.get('tutorial') as BaseTutorialStore;
  return tutorialStore.tutorialStartDate;
};

export const getTutorialIsExpired = (state: StateType) => {
  const tutorialStore = state.get('tutorial') as BaseTutorialStore;
  return tutorialStore.isTutorialExpired;
};

export const getTutorialStatus = (state: StateType) => {
  const tutorialStore = state.get('tutorial') as BaseTutorialStore;
  return tutorialStore.status;
};

export const getTutorialTotalSteps = (state: StateType) => {
  const tutorialStore = state.get('tutorial') as BaseTutorialStore;
  return tutorialStore.tutorialTotalSteps ?? 1;
};
